<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div id="roleHeader" class="page-name color-71aa3f">
                        Create Role
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backrolelist">Back</button>
                </div>
                <div class="admin-page-content">
                    <form id="Roleform">
                        <div class="forms-container">
                            <div class="row no-margin">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                    <div class="alert alert-success" id="alertSuccess">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <span>Role Added Successfully</span>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                    <div class="alert alert-danger" id="alertError">
                                        <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                        <span id="errorMsg" class="error"></span>
                                    </div>
                                </div>
                                <div class="col-6 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label"><strong>Role Name</strong></div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <template v-if="role_id >= 7 || role_id == 0">
                                            <input type="text" id="role_name" name="role_name" class="form-control"
                                                   placeholder="Enter Role Name" v-model="role_name"
                                                   v-validate="'required'">
                                            <!--v-validate="'required|max:190'">-->
                                        </template>
                                        <template v-else>
                                            <span class="form-control">{{role_name}}</span>
                                            <input type="hidden" id="role_name" name="role_name" :value='role_name'>
                                        </template>
                                        <div class="requiredstar">*</div>
                                        <span v-show="errors.has('role_name')" class="help is-danger" v-if="errors.has('role_name')"><font color="red">Role Name is Required</font></span>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="col-12 paddingleft0">
                                        <input type="checkbox" id="markallcheck">
                                        <label id="markCheckBox" class="permission-label" for="markallcheck">Mark ALL</label>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Customer
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'customer'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Contact
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'contact'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Task
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'task'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Calls/Email
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'calls_emails'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Cases
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'case'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>

                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Resale
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'resale'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>

                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Dunning  Notice
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'dunning_notices'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Welcome Letter
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'welcome_letter'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Employees
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'employee'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Jobs
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'jobs'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Email History
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'email_history'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Business Unit
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'business_unit'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Role
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'role'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Contact Request
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'contact_request'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Email Bounce
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'email_bounce'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12 forms-block">
                                    <div class="row ml-0 mr-0">
                                        <h3 class="color-23727b font-text-regular-san width-full float-l mb-0 pb-1">
                                            Summary
                                        </h3>
                                        <div class="clearfix"></div>
                                        <template v-for="(permission, index) in permissions">
                                            <template v-if="permission.module_name == 'summary'">
                                                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                                                    <div class="block-form">
                                                        <div class="form-group">
                                                            <label><input type="checkbox" id="jack" v-bind:value="permission.id" v-model="roleData.checkedPermissions" name="checkedPermissions[]">
                                                                <span class="permission-label">{{ permission.description }}</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="col-12 paddingleft0">
                                        <input id="addRoleBtn" type="submit" value="Save" class="btn general-button btn-primary" v-on:click.prevent="AddRole()">
                                        <input id="addAndContinueRoleBtn" type="submit" value="Save and Continue" class="btn general-button btn-primary" v-on:click.prevent="AddRole(flag='Save and Continue')">
                                        <input id="CancelRole" type="submit" value="Cancel" class="btn general-button btn-primary" v-on:click.prevent="backrolelist">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import index from "../../router";
    import Vue from 'vue';
    import EventBus from '../event-bus';
    // import {addTask, getCustomer, updateTask, list_taskUrl} from '../../config'
    import FrontFooter from '@/components/partials/FrontFooter';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);
    import SessioMixin from '../../mixins/sessionmixin';
    // import moment from 'moment'

    var segments = '';
    export default {
        name: "RoleCreate",
        components: {
            'app-footer': FrontFooter,
        },
        mixins: [SessioMixin],
        data() {
            return {
                cantAccessPage: true,
                isLoggedIn: false,
                created_by: '',
                updated_by: '',
                role_id: 0,
                role_name: '',
                errorMsg: '',
                permissions: {},
                roleData: {
                    name: '',
                    checkedPermissions: []
                },
                permissionschek: [],
                allCusstomerSelected: false,
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            }
            $.ajax({
                url: process.env.ROOT_API + "/permissions/get",
                type: "GET",
                // data: fields,
                headers: {
                    'Accept': 'application/json',
                    "Access-Control-Allow-Origin": '*',
                    "Authorization": "Bearer " + localStorage.getItem("api_token"),
                    'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                    "Cache-Control": "no-cache"
                },
                dataType: 'json',
                success: function (data) {
                    app.permissions = data.content;
                    // console.log(app.permissions);
                },
                error: function (jqXHR, exception) {
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server can not be reachable";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem('user_obj');
                            localStorage.removeItem('api_token');
                            //EventBus.$emit("logged-in", true, "", "");
                            self.$router.push("/login");
                        }
                    }
                }
            });
            app.loadRole();
        },
        mounted: function () {
            $(".removeActive").removeClass('active');
            $("#menurole").addClass('active');
            //    setTimeout(function () {
            /*$('.datetimepicker').bootstrapMaterialDatePicker({
             // format: 'dddd DD MMMM YYYY - HH:mm',
             format: 'MM/DD/YYYY HH:mm:ss',
             clearButton: true,
             weekStart: 1
             });*/
            // },1000);
            var self = this;
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            $(function () {
                $("#due_date").on('change', function () {
                    self.due_date = $("#due_date").val();
                })
            });

            var path = window.location.pathname;
            segments = path.split("/");
            var self = this;
            if (segments[3]) {
                self.showLoader();
                self.loadRole();
                $('#addAndContinueRoleBtn').hide();
                $("#addRoleBtn").val('Update');
                $("#roleHeader").text('Edit Role');
            }
            $('#markallcheck').click(function () {
                var selected = [];
                if ($('#markallcheck').is(':checked')) {
                    //console.log('Checked');
                    self.permissions.forEach(function (permissions) {
                        selected.push(permissions.id);
                    });
                    $("#markCheckBox").text('UnMark ALL');
                } else {
                    //console.log('Not Checked');
                    $("#markCheckBox").text('Mark ALL');
                }
                self.roleData.checkedPermissions = selected;
            });
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_add_new_roles') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            backrolelist() {
                var self = this;
                self.$router.push('/listrole');
            },
            AddRole(flag) {
                this.$validator.validate().then(result => {
                    if (result) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var self = this;
                        self.showLoader();
                        //console.log(segments[3]);
                        if (segments[3]) {
                            //console.log(segments[3]);
                            $("#addRoleBtn").val('Updating ...');
                            $("#addRoleBtn").prop('disabled', true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelRole").prop('disabled', true);
                        } else {
                            if (flag == 'Save and Continue') {
                                $("#addAndContinueRoleBtn").val('Saving ...');
                                $("#addAndContinueRoleBtn").prop('disabled', true);
                                $("#addRoleBtn").prop('disabled', true);
                                $("#CancelRole").prop('disabled', true);
                            } else {
                                $("#addRoleBtn").val('Saving ...');
                                $("#addRoleBtn").prop('disabled', true);
                                $("#addAndContinueRoleBtn").prop('disabled', true);
                                $("#CancelRole").prop('disabled', true);
                            }
                        }

                        var fields = $('#Roleform').serializeArray();
                        this.$validator.validateAll();
                        this.$validator.errors.clear();

                        if (segments[3]) {
                            fields.push({name: 'id', value: segments[3]});
                        } else {
                            fields.push({name: 'id', value: 0});
                        }
                        $.ajax({
                            url: process.env.ROOT_API + "/role/create",
                            type: "POST",
                            data: fields,
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.hideLoader();
                                if (segments[3]) {
                                    //console.log(segments[3]);
                                    $("#addRoleBtn").val('Update');
                                    $("#addRoleBtn").prop('disabled', false);
                                    $("#addAndContinueRoleBtn").prop('disabled', false);
                                    $("#CancelRole").prop('disabled', false);

                                } else {
                                    if (flag == 'Save and Continue') {
                                        $("#addAndContinueRoleBtn").val('Save and Continue');
                                        $("#addAndContinueRoleBtn").prop('disabled', false);
                                        $("#addRoleBtn").prop('disabled', false);
                                        $("#CancelRole").prop('disabled', false);
                                    } else {
                                        $("#addRoleBtn").val('Save');
                                        $("#addRoleBtn").prop('disabled', false);
                                        $("#addAndContinueRoleBtn").prop('disabled', false);
                                        $("#CancelRole").prop('disabled', false);

                                    }
                                }
                                if (data.status == "success") {
                                    if (flag == 'Save and Continue') {
                                        $('html, body').animate({scrollTop: '0px'}, 500);
                                        $(".alert-success").parent().removeClass('hide');
                                        $(".alert-success").parent().addClass('show');
                                        self.role_name = '';
                                        self.roleData.checkedPermissions = [];
                                        $('#markallcheck').prop('checked', false);
                                        setTimeout(function () {
                                            $('.alert-success').parent().removeClass('show');
                                            $('.alert-success').parent().addClass('hide');
                                        }, 5000);

                                    } else {
                                        self.$router.push('/listrole');
                                    }

                                } else {
                                    // $(".alert-danger").parent().removeClass('hide');
                                    // $(".alert-danger").parent().addClass('show');
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);
                                    }
                                }

                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (segments[3]) {
                                    $("#addRoleBtn").val('Update');
                                    $("#addRoleBtn").prop('disabled', false);
                                    $("#addAndContinueRoleBtn").prop('disabled', false);
                                    $("#CancelRole").prop('disabled', false);
                                    $("#errorMsg").html(jqXHR.responseJSON.message);
                                    $(".alert-danger").parent().removeClass('hide');
                                    $(".alert-danger").parent().addClass('show');
                                    setTimeout(function () {
                                        $('.alert-danger').parent().removeClass('show');
                                        $('.alert-danger').parent().addClass('hide');
                                    }, 5000);
                                } else {

                                    if (flag == 'Save and Continue') {
                                        $("#addAndContinueRoleBtn").prop('disabled', false);
                                        $("#addAndContinueRoleBtn").val('Save and Continue');
                                        $("#addRoleBtn").prop('disabled', false);
                                        $("#CancelRole").prop('disabled', false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        self.role_name = '';
                                        self.roleData.checkedPermissions = [];
                                        $('#markallcheck').prop('checked', false);
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);

                                    } else {
                                        $("#addRoleBtn").val('Save');
                                        $("#addRoleBtn").prop('disabled', false);
                                        $("#addAndContinueRoleBtn").prop('disabled', false);
                                        $("#CancelRole").prop('disabled', false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        setTimeout(function () {
                                            $('.alert-danger').parent().removeClass('show');
                                            $('.alert-danger').parent().addClass('hide');
                                        }, 5000);

                                    }

                                    if (jqXHR.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (jqXHR.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem('user_obj');
                                            localStorage.removeItem('api_token');
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass('hide');
                                        $(".alert-danger").parent().addClass('show');
                                        setTimeout(function () {
                                            $('.alert-danger').removeClass('show');
                                            $('.alert-danger').addClass('hide');
                                        }, 5000);
                                    }
                                }
                            }
                        });
                    }
                });
            },

            loadRole() {

                var path = window.location.pathname;
                segments = path.split("/");
                // console.log(segments[3]);
                var self = this;
                if (segments[3] > 0) {
                    $.ajax({
                        url: process.env.ROOT_API + "/role/" + segments[3],
                        type: "GET",
                        headers: {
                            'Accept': 'application/json',
                            "Access-Control-Allow-Origin": '*',
                            "Authorization": "Bearer " + localStorage.getItem("api_token"),
                            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            "Cache-Control": "no-cache"
                        },
                        dataType: 'json',
                        success: function (data) {
                            console.log(JSON.stringify(data))
                            self.hideLoader();
                            self.role_id = data.content.id;
                            self.role_name = data.content.role_name;
                            self.roleData.name = data.content.name;
                            self.roleData.checkedPermissions = data.assigned_permission;
                            if (self.roleData.checkedPermissions.length >= 42) {
                                $("#markCheckBox").text('UnMark ALL');
                                $('#markallcheck').attr('checked', 'checked');
                            } else {
                                $("#markCheckBox").text('Mark ALL');
                                $('#markallcheck').removeAttr('checked');
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.hideLoader();
                            if (jqXHR.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('api_token');
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    })
                }
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/rolePermission/RoleCreate.vue